/**
 * Legacy ApiService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.api`) keep resolving.
 *
 * The actual `ApiService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts as a downgrade
 * of the unified Angular 18 ApiService at
 * apps/b2b-frontend/app/core/api/api.service.ts.
 *
 * The Angular 18 facade exposes `user` and `system` as native sub-services
 * (HttpClient + typed responses); the remaining ~55 sub-services keep their
 * AngularJS implementations for now and are accessed lazily through
 * `$injector` until each one is migrated in a follow-up PR.
 *
 * Do NOT register `.service('ApiService', ...)` here — it would shadow the
 * downgraded service.
 */
angular.module('acme.common.service.api', [
  'acme.common.service.administrationApi',
  'acme.common.service.analyticsApi',
  'acme.common.service.cartApi',
  'acme.common.service.comboApi',
  'acme.common.service.couponsApi',
  'acme.common.service.customFieldsApi',
  'acme.common.service.customerFeesApi',
  'acme.common.service.rateCardsApi',
  'acme.common.service.customerServiceApi',
  'acme.common.service.customersApi',
  'acme.common.service.departmentsApi',
  'acme.common.service.discountsApi',
  'acme.common.service.donationsApi',
  'acme.common.service.emailStatusApi',
  'acme.common.service.entityApi',
  'acme.common.service.entitlementsApi',
  'acme.common.service.eventApi',
  'acme.common.service.featureToggle',
  'acme.common.service.financeApi',
  'acme.common.service.formApi',
  'acme.common.service.glcodesApi',
  'acme.common.service.groupsApi',
  'acme.common.service.historyApi',
  'acme.common.service.inventoryApi',
  'acme.common.service.inventoryB2CApi',
  'acme.common.service.importJobsApi',
  'acme.common.service.importJobExecutionsApi',
  'acme.common.service.importExportsApi',
  'acme.common.service.lockApi',
  'acme.common.service.membershipApi',
  'acme.common.service.navigationApi',
  'acme.common.service.offline',
  'acme.common.service.ordersApi',
  'acme.common.service.organizationsApi',
  'acme.common.service.partnersApi',
  'acme.common.service.passesApi',
  'acme.common.service.permissionsApi',
  'acme.common.service.photosApi',
  'acme.common.service.posApi',
  'acme.common.service.posCloudConfiguration',
  'acme.common.service.priceApi',
  'acme.common.service.programApi',
  'acme.common.service.proxyUserApi',
  'acme.common.service.refundsApi',
  'acme.common.service.reportingApi',
  'acme.common.service.reservation',
  'acme.common.service.resourceApi',
  'acme.common.service.rolesApi',
  'acme.common.service.rulesEngineApi',
  'acme.common.service.settlementsApi',
  'acme.common.service.subscriptionsApi',
  'acme.common.service.systemApi',
  'acme.common.service.tenantApi',
  'acme.common.service.terminalsApi',
  'acme.common.service.themesApi',
  'acme.common.service.ticketsApi',
  'acme.common.service.userApi',
  'acme.common.service.userPreferencesApi',
  'acme.common.service.walkinsApi',
  'acme.common.service.loggerApi',
  'acme.common.service.dedupeApi',
  'acme.common.service.textVariablesApi',
  'acme.common.service.householdApi',
  'acme.common.service.sfdcApi',
]);
